module.exports = __webpack_public_path__ + "img/hallelujah.3395989a.jpg";